module.exports = __webpack_public_path__ + "static/media/Slack_Channel.4beedba9.jpg";